import React from 'react';
import { motion } from 'framer-motion';

const PageHero = ({
  badge,
  title,
  subtitle,
  children,
  badgeClassName = "text-teal",
  badgeLineClassName = "bg-teal",
  className = "",
  contentClassName = ""
}) => {
  return (
    <div className={`relative bg-navy pt-32 pb-28 lg:pt-40 lg:pb-36 overflow-hidden ${className}`}>
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-clinical/20 rounded-bl-[200px] pointer-events-none"></div>
      <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-teal/10 rounded-full blur-3xl pointer-events-none"></div>
      
      <div className="container mx-auto px-4 lg:px-8 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className={contentClassName}
        >
          {badge && (
            <div className="flex items-center justify-center space-x-3 mb-6">
              <span className={`w-8 h-[2px] ${badgeLineClassName}`}></span>
              <span className={`font-bold tracking-widest text-xs uppercase ${badgeClassName}`}>
                {badge}
              </span>
              <span className={`w-8 h-[2px] ${badgeLineClassName}`}></span>
            </div>
          )}

          {title && (
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight">
              {title}
            </h1>
          )}

          {subtitle && (
            <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
              {subtitle}
            </p>
          )}

          {children}
        </motion.div>
      </div>
    </div>
  );
};

export default PageHero;
